import React from 'react';
import ApolloError from '@shared/components/ApolloError';
import ReportDataMapper from '../../../mappers/ReportDataMapper';
import BaselineReportTable from './BaselineReportTable';
import { useQuery } from '@apollo/client';
import GET_FDA_CONTRACT_BASELINE_REPORT from '../../../queries/getFdaContractBaselineReportQuery';

/**
 * @typedef {object} SACBaselineViewProps
 * @property {Array<number>} [ohts]
 * @property {number} [orgId]
 */

/**
 * @param {SACBaselineViewProps} props
 */
const SACBaselineView = props => {
  const { ohts, orgId } = props;

  const {
    data: baselineData,
    loading: baselineDataLoading,
    error: baselineDataError
  } = useQuery(GET_FDA_CONTRACT_BASELINE_REPORT, {
    variables: { ohts, orgId }
  });

  const baselineReportData = baselineData?.fdaContractBaselineReport.map(
    ReportDataMapper.mapFdaPracticeArea
  );

  if (baselineDataError) {
    return <ApolloError />;
  }

  return <BaselineReportTable loading={baselineDataLoading} data={baselineReportData} />;
};

export default SACBaselineView;
